// export const headApi = `https://api.bangles.org.in/api/rest`;

// export const headApi = `https://api.inshabangles.com/inshaApp`;
// export const headApi = `https://api.inshabangles.com/indianb2b`;
export const headApi = `https://api.indianbangles.in/b2bPlatform`;

// export const headApi = `http://localhost:8089/api`;

export const username = "admin";
export const password = "Insha_!@#$21Bangles";

export const credentials = btoa(`${username}:${password}`);

export function convertToNextTenth(num) {
    return (Math.ceil(num * 10) / 10).toFixed(2);
}